import { createApp } from 'vue';
import PageProperties from './pageproperties/PageProperties.vue';

const MOUNT_ID = 'vue-page-properties';

function initPageProperties(): boolean {
  const mountPoint = document.getElementById(MOUNT_ID);
  if (!mountPoint || mountPoint.dataset.mounted === '1') {
    return !!mountPoint;
  }
  mountPoint.dataset.mounted = '1';
  createApp(PageProperties).mount(mountPoint);
  return true;
}

// The block lives in the node_commands region, which can be delivered via
// BigPipe — mirror the resilient mount strategy used by AreasBlock.
if (!initPageProperties()) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      if (!initPageProperties()) {
        observeForMountPoint();
      }
    });
  } else {
    observeForMountPoint();
  }
}

function observeForMountPoint(): void {
  const observer = new MutationObserver((_mutations, obs) => {
    if (initPageProperties()) {
      obs.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => {
    observer.disconnect();
    console.warn('[PageProperties] Gave up waiting for mount point after 10s');
  }, 10000);
}
